import { useEffect, useState } from "react";
import { MdPushPin } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setMarketName,
  setMarketOddsData,
  setRunningData,
} from "../../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import MatchDateAndInplay from "./MatchDateAndInplay";

function SportsMatchesList({
  sportId,
  sportName = "Cricket",
  matchesList = [],
  compactDesign = false,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.user.token);

  const [pinnedEvents, setPinnedEvents] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("pinnedEvents") || "[]");
    setPinnedEvents(stored);
  }, []);

  const handlePinClick = (eventId) => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    let updatedPins = [...pinnedEvents];

    if (updatedPins.includes(eventId)) {
      updatedPins = updatedPins.filter((id) => id !== eventId);
    } else {
      updatedPins.push(eventId);
    }

    setPinnedEvents(updatedPins);
    localStorage.setItem("pinnedEvents", JSON.stringify(updatedPins));

    window.dispatchEvent(new Event("pinnedEventsUpdated"));
  };

  return (
    <div className="w-full h-full flex flex-col">
      {Array.isArray(matchesList) &&
        matchesList.map(
          (
            {
              eventName,
              sportId: sportID,
              competitionId,
              eventId,
              marketId,
              joinedMarketIds,
              matchRunners,
              markets,
              openDate,
              matchOdds,
              bm,
              fancy,
              pc,
            },
            i
          ) => {
            const isPinned = pinnedEvents.includes(eventId);

            return (
              <div
                key={`${i + 1}-${eventId}`}
                className={`w-full px-2 py-1 flex flex-row justify-between items-center border-b border-[#c8ced3] ${
                  compactDesign ? "min-h-8" : "min-h-12"
                }`}
              >
                <p
                  role="button"
                  onClick={() => {
                    dispatch(setRunningData(matchRunners));
                    dispatch(setMarketName(markets));
                    dispatch(
                      setMarketOddsData({
                        data: { data: matchOdds },
                        sport: sportName,
                      })
                    );
                    navigate(
                      `/full-market?eventType=${
                        sportId || sportID
                      }&eventId=${eventId}&marketId=${marketId}&joinedMarketIds=${joinedMarketIds}&competitionId=${competitionId}&bm=${bm}&fancy=${fancy}&pc=${pc}&eventName=${eventName}`
                    );
                  }}
                  className={`font-semibold text-[#2789ce] ${
                    compactDesign ? "text-xs" : "text-sm"
                  }`}
                >
                  {eventName}
                  <MatchDateAndInplay
                    inplay={matchOdds?.some((odds) => odds?.inplay) || false}
                    openDate={openDate}
                  />
                </p>

                <div className="flex flex-row justify-between items-center gap-1">
                  {bm && (
                    <div
                      className={`aura-market-status aura-bm ${
                        compactDesign ? "text-[10px]" : "text-[12px]"
                      }`}
                    >
                      BM
                    </div>
                  )}
                  {fancy && (
                    <div
                      className={`aura-market-status aura-f ${
                        compactDesign ? "text-[10px]" : "text-[12px]"
                      }`}
                    >
                      F
                    </div>
                  )}
                  {pc && (
                    <div
                      className={`aura-market-status aura-s ${
                        compactDesign ? "text-[10px]" : "text-[12px]"
                      }`}
                    >
                      S
                    </div>
                  )}
                  <div
                    onClick={() => handlePinClick(eventId)}
                    className={`ml-2 rounded-full flex flex-row justify-center items-center p-[2px] w-[22px] h-[22px] cursor-pointer transition-all duration-200 ${
                      isPinned
                        ? "bg-emerald-100 dark:bg-dark-bg border border-emerald-500"
                        : "border border-[#7e97a6] bg-transparent dark:bg-dark-bg"
                    }`}
                  >
                    <MdPushPin
                      color={isPinned ? "#059669" : "#7e97a6"}
                      size={16}
                    />
                  </div>
                </div>
              </div>
            );
          }
        )}
      {matchesList && matchesList.length === 0 && (
        <div className="w-full h-full flex flex-row justify-center items-center text-sm font-semibold text-gray2">
          No match scheduled.
        </div>
      )}
    </div>
  );
}

export default SportsMatchesList;
